





































































import { defineComponent, toRefs, PropType, computed, Ref, nextTick } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  DARK_POST_STATUS_MAP as DarkPostStatus,
  SmartTextSource,
  PrecheckResult
} from '@tt4b/ttam-enums';
import { useCreativeTextValidate, useCreativeIs, useCreativeActionTypeIs } from '@tt4b/ttam-hooks';
import { IdentityFullInfo } from '../../identity/types';
import { getImgSrcByEnv, imgSrcPrefix } from '@tt4b/ttam-utils';
import { trackEvent } from './../../../utils/index';
import TtamAdTextCheck from '../ad-text/check/index.vue';
import TtamAdText from '../ad-text/textarea/index.vue';
import CreativeTitleSuggestion from '@/components/common/creative-title-suggestion/index.vue';
import {
  useCheckTitle,
  useCreativeSmartDrawerHandler,
  useTitleValidateStatus,
  MAX_TITLE_LENGTH,
  useTrackTitleEvent,
} from '../ad-text/hooks';
import { useTitleSuggestion } from './../../common/creative-title-suggestion/use-title-suggestion';
const spaceEnum = ' ';
const name = 'ttam-affiliate-library-video-result-item';
export default defineComponent({
  name,
  components: {
    TtamAdTextCheck,
    TtamAdText,
    CreativeTitleSuggestion,
  },
  props: {
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeIndex: {
      type: Number,
      default: 0,
    },
    createMode: {
      type: Object as PropType<Ref<string>>,
    },
    originEditFormData: {
      type: Object as PropType<Partial<FullNormalFormData>>,
      default: () => ({}),
    },
    identityInfo: {
      type: Object as PropType<IdentityFullInfo>,
      default: () => ({}),
    },
    precheckResult: {
      type: Object as PropType<PrecheckResult>,
      default: () => ({
        materialResults: [],
        summaryResults: [],
      }),
    },
  },
  setup(props, { emit }) {
    const {
      creativeData: localCreativeData,
      campaignData,
      adgroupData,
      creativeIndex,
      createMode,
      originEditFormData,
    } = toRefs(props);

    const { isChecking, computedTitleSuggestionList, checkTitle, computedTypoModel, clearTypoModel } = useCheckTitle({
      adgroupData,
      creativeData: localCreativeData,
      emit,
    });
    const { handleOpenSmartText, handleOpenSmartTranslation } = useCreativeSmartDrawerHandler();
    const { refTitle, isValidateSuccess } = useTitleValidateStatus();
    const { triggerText } = useTrackTitleEvent({ adgroupData, creativeData: localCreativeData });
    const {
      debounceGetTitleSuggestion,
      hide: hideTitleSuggestion,
      immediateDebounceGetTitleSuggestion,
    } = useTitleSuggestion({ adgroupData, campaignData, creativeData: localCreativeData });
    const _title = computed({
      get: () => localCreativeData.value.title || '',
      set: val => {
        // 用户input的时候清空错别字模型
        clearTypoModel();
        emit('creative-text-change', {
          textVal: val,
          index: creativeIndex.value,
        });
      },
    });
    const darkPostStatus = computed({
      get() {
        return localCreativeData.value.darkPostStatus !== DarkPostStatus.ON;
      },
      set(val) {
        trackEvent('ad_start_with_product_push_ad_mode_only', { value: val });
        emit('creative-only-ads-change', {
          darkPostStatus: val ? DarkPostStatus.OFF : DarkPostStatus.ON,
          index: creativeIndex.value,
        });
      },
    });
    const { isEdit } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    const { isNative } = useCreativeIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      normalCreativeData: localCreativeData,
      createMode,
    });
    const { adTextValidator } = useCreativeTextValidate({
      isNative,
      originEditFormData,
      isEdit,
      customFormData: localCreativeData.value,
    });
    const getVideoImgUrl = () => getImgSrcByEnv({ URL: imgSrcPrefix.URL }, localCreativeData.value?.videoInfo.coverUri);
    const handleClearValidate = () => {
      refTitle.value.clearValidate();
    };
    const onCreativeDataChange = data => {
      console.log(data);
    };
    const handleTitleBlur = () => {
      if (!_title.value) {
        return;
      }
      checkTitle();
      triggerText();
      nextTick(() => {
        hideTitleSuggestion(true);
      });
    };
    let debounceFun = null;
    const checkTitleSuggestion = () => {
      if (_title.value.slice(-1) === spaceEnum) {
        immediateDebounceGetTitleSuggestion(_title.value);
        debounceFun && debounceFun.cancel();
      } else {
        debounceFun = debounceGetTitleSuggestion;
        debounceGetTitleSuggestion(_title.value);
      }
    };
    return {
      name,
      _title,
      localCreativeData,
      darkPostStatus,
      adTextValidator,
      getVideoImgUrl,
      isChecking,
      computedTitleSuggestionList,
      SmartTextSource,
      handleOpenSmartText,
      handleClearValidate,
      onCreativeDataChange,
      handleTitleBlur,
      checkTitleSuggestion,
      checkTitle,
      MAX_TITLE_LENGTH,
      refTitle,
      isValidateSuccess,
      computedTypoModel,
    };
  },
});
